import { Component, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

/*Services */
import { ObjectsService } from '@services/http/objects.service';
import { DevicesService } from '@services/http/devices.service';
import { ObservableObjectsService } from '@services/http/observable-objects.service';
import { CachedDataService, AppService } from '@services';

/*Models*/
import { ObservableObject } from '@models/observable-object';

/*Plugins*/
import { BsModalComponent, BsModalService } from 'ng2-bs3-modal';

import { CONFIG } from '../../../config';

@Component({
  selector: 'add-object-modal',
  templateUrl: './add-object.component.html'
})

export class AddObjectComponent implements OnInit {

  @ViewChild('addObjectModal')
  addObjectModal: BsModalComponent;
  @ViewChild('addDeviceModal')
  addDeviceModal: BsModalComponent;

  addDeviceToCreated = false;
  observableObjects: ObservableObject[];
  addObjectForm: FormGroup;

  errorMessage = '';
  ifNeedCaptcha = false;
  ifNeedSelectProvider = false; // Если нужно выбрать провайдера перед добавлением
  providersArray = []; // Список провадеров для выбора перед добавлением устройства
  ifNeedSelectDevice = false; // Если нужно выбрать одно устройство
  devicesArray = []; // Список устрйоств для выбора перед добавлением устройства

  typeObject = '';
  trySend = false;
  typeObjectName = {
    'Moto': { name: 'мотоцикл', nameDecl: 'мотоцикла' },
    'Car': { name: 'автомобиль', nameDecl: 'автомобиля' },
    'SUV': { name: 'внедорожник', nameDecl: 'внедорожника' },
    'QuadBike': { name: 'квадроцикл', nameDecl: 'квадроцикла' }
  };
  btnText = {
    text: 'Добавить',
    defaultText: 'Добавить',
    loadText: 'Обработка..'
  };
  extraTYpe = CONFIG.extra;
  capcha = {
    capchaId: null,
    capchaUri: null
  };
  constructor(
    private objectsService: ObjectsService,
    private devicesService: DevicesService,
    private modalservice: BsModalService,
    private cachedDataService: CachedDataService,
    private observableObjectsService: ObservableObjectsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private appService: AppService) {
    objectsService.updateObjects.subscribe(() => {
      this.getObject();
    });
  }

  ngOnInit() {
    this.initForm();
    this.getObject();

  }

  initForm() {
    this.ifNeedCaptcha = false;
    this.ifNeedSelectDevice = false;
    this.ifNeedSelectProvider = false;
    this.providersArray = [];
    this.devicesArray = [];
    this.errorMessage = '';

    this.addObjectForm = this.formBuilder.group({
      userId: null,
      name: ['', [Validators.required]],
      phonenumber: [''],
      objecttype: ['Transport'],
      objectid: [''],
      extra: [''],
      login: ['', [Validators.required]],
      password: ['', [Validators.required]],
      capchacode: [''],
      provider: [''],
      externalDeviceId: ['']
    });
    this.addObjectForm.controls['password'].setErrors({ 'error': '' });
  }


  getObject() {
    this.observableObjectsService.getAll().subscribe(response => {
      this.observableObjects = this.appService.filterObjects(response);
    }, error => console.log('from component error', error));
  }
  openForm(type: string, isCreated?: boolean) {
    this.addDeviceModal.close();
    this.typeObject = type;
    this.addObjectModal.open();
    if (isCreated) {
      if (this.observableObjects.length) {
        /*set by default */
        this.addObjectForm.controls['name'].setValue(this.observableObjects[0].name);
        this.addObjectForm.controls['objectid'].setValue(this.observableObjects[0].id);
      }
      this.addDeviceToCreated = true;
    } else {
      this.addObjectForm.controls['name'].setValue('');
      this.addObjectForm.controls['objectid'].setValue('');
      this.addDeviceToCreated = false;
    }
  }
  openDevice() {
    this.addDeviceModal.open();
    
  }
  createObject() {
    // this.router.navigate(['/online', '677d371a-dfed-4ea5-bd5e-4b19dfb4a542', 'state']);
    if (this.trySend) {
      return false;
    }
    this.errorMessage = '';
    if (this.addObjectForm.invalid) {
      const controls = this.addObjectForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }
    if(this.cachedDataService.currentUserId){
      this.addObjectForm.get('userId').setValue(this.cachedDataService.currentUserId)
    }
    
    this.trySend = true;
    this.btnText.text = this.btnText.loadText;

    if (this.addDeviceToCreated ||
      this.ifNeedCaptcha ||
      this.addObjectForm.controls['objectid'].value.length ||
      this.ifNeedSelectProvider ||
      this.ifNeedSelectDevice) {
      this.createDevice();
    } else {
      let extra = '';
      switch (this.typeObject) {
        case 'Moto': {
          extra = this.extraTYpe.moto;
          break;
        }
        case 'Car': {
          extra = this.extraTYpe.car;
          break;
        }
        case 'SUV': {
          extra = this.extraTYpe.SUV;
          break;
        }
        case 'QuadBike': {
          extra = this.extraTYpe.quadBike;
          break;
        }
        default: {
          extra = this.extraTYpe.car;
          break;
        }
      }
      this.objectsService.addObject(
        this.addObjectForm.value.name,
        this.addObjectForm.value.objecttype,
        extra,
        this.addObjectForm.value.userId)
        .subscribe(response => {
          this.addObjectForm.controls['objectid'].setValue(response.id);
          this.createDevice();
        },
          error => {
            if (error.error) {
              error = error.error;
            }
            this.trySend = false;
            this.btnText.text = this.btnText.defaultText;
            console.log(error.type);
            this.showErorr(error);
          }
        );
    }
  }
  createDevice() {
    const body: object = {};
    body['Login'] = this.addObjectForm.value.login;
    body['Password'] = this.addObjectForm.value.password;
    body['ObjectId'] = this.addObjectForm.value.objectid;
    body['PhoneNumber'] = this.addObjectForm.value.phonenumber.replace(/\D/g, '');
    if(this.addObjectForm.value.userId){
      body['userId'] = this.addObjectForm.value.userId;
    }
    
    
    if (this.capcha.capchaId && this.capcha.capchaUri && this.ifNeedCaptcha) {
      body['capchaId'] = this.capcha.capchaId;
      body['capchaCode'] = this.addObjectForm.controls['capchacode'].value;

      this.addObjectForm.controls['password'].setErrors(null);
    }
    if (this.ifNeedSelectProvider) {
      body['provider'] = this.addObjectForm.controls['provider'].value;
    }
    if (this.ifNeedSelectDevice) {
      body['externalDeviceId'] = this.addObjectForm.controls['externalDeviceId'].value;
    }


    this.devicesService.createDevice(body)
      .subscribe(response => {
        this.trySend = false;
        this.btnText.text = this.btnText.defaultText;
        this.typeObject = '';
        if (response) {
          this.initForm();
          this.addObjectModal.close();
          this.objectsService.updateObjects.emit();

          const that = this;
          setTimeout(function () {
            that.router.navigate(['/online', this.addObjectForm.value.objectid, response[0].id, 'state']);
          }, 1000);
        }

      },
        error => {
          this.trySend = false;
          this.btnText.text = this.btnText.defaultText;

          if (error.error) {
            error = error.error;
          }
          if (error.capchaId && error.capchaUri) {
            /*Если нужно ввести капчу */
            if (error.errorMessage !== 'Капча введена не верно') {
              this.addObjectForm.controls['password'].setErrors({ 'error': 'Пароль неверный' });
            }
            this.errorMessage = error.errorMessage;
            this.ifNeedCaptcha = true;
            this.capcha.capchaId = error.capchaId;
            this.capcha.capchaUri = error.capchaUri + '?version=' + new Date().getTime();
            this.addObjectForm.controls['capchacode'].setValidators([Validators.required]);
          } else if (error.type === 'SelectProviderRequired' && error.providers && error.providers.length) {
            /*Если нужно выбрать провайдера */
            this.ifNeedSelectProvider = true;
            this.providersArray = error.providers;
            this.addObjectForm.get('provider').setValidators(Validators.required);

          } else if (error.type === 'SelectDeviceRequired' && error.devices && error.devices.length) {
            /*Если нужно выбрать устройство */
            this.ifNeedSelectDevice = true;
            this.devicesArray = error.devices;
            this.addObjectForm.get('externalDeviceId').setValidators(Validators.required);
          } else {
            this.showErorr(error);
          }
        }
      );
  }
  showErorr(error) {
    if (error.errorMessage && error.errorMessage.length) {
      this.errorMessage = error.errorMessage;
    } else {
      const errors = error.modelState;
      for (error in errors) {
        this.addObjectForm.controls[errors[error].field.toLowerCase()].setErrors({ 'error': errors[error].errors });
      }
    }
  }

  onChangeUsername(value) {
    this.addObjectForm.controls['phonenumber'].setValue(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/add-object-modal/add-object.component.ts